import { render, staticRenderFns } from "./PackageEditor.vue?vue&type=template&id=50dd681a&scoped=true&"
import script from "./PackageEditor.vue?vue&type=script&lang=js&"
export * from "./PackageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PackageEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PackageEditor.vue?vue&type=style&index=1&id=50dd681a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd681a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dd681a')) {
      api.createRecord('50dd681a', component.options)
    } else {
      api.reload('50dd681a', component.options)
    }
    module.hot.accept("./PackageEditor.vue?vue&type=template&id=50dd681a&scoped=true&", function () {
      api.rerender('50dd681a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/PackageEditor.vue"
export default component.exports